<div class="bg--white">
  <scc-dsm3-nav-breadcrumbs [items$]="breadcrumbsItems$"></scc-dsm3-nav-breadcrumbs>
</div>

<section class="request__filter" *ngIf="authService.isAuthenticated()">
  <div class="container">
    <!-- HEADER DETAIL -->
    <div class="row" *ngIf="request">
      <div class="col-md-6 text-left">
        <h1 color="black">
          {{ request?.detail?.requestOperationType | uppercase }} - {{ request?.detail?.requestMainId | uppercase }}
        </h1>
      </div>
      <div class="col-md-6 text-right btn-actions">
        <div class="btn-group">
          <button class="edp-btn btn-gray" (click)="closeRequestDetail()">Voltar</button>
        </div>
        <!-- BUTTON ACTION NOT RET && REOPEN -->
        <div class="btn-group" *appRequestPermission="internalNotesPermission">
          <button
            class="edp-btn btn-yellow"
            *ngIf="request?.detail?.statusUniqueCode === 'pt.edp.request?.status.3'"
            (click)="reOpenRequest(request?.detail)"
          >
            Reabrir
          </button>
          <button
            type="button"
            *ngIf="showActions()"
            class="edp-btn btn-yellow dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Ações <span class="caret"></span>
          </button>
          <ul class="dropdown-menu dropdown-menu-right">
            <li
              class="cursor-pointer"
              *ngIf="request?.possibleStatus.length > 0"
              tabindex="0"
              (click)="changeStatus(request?.detail)"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && changeStatus(request?.detail)"
            >
              Alterar estado
            </li>
            <li
              class="cursor-pointer"
              tabindex="0"
              (click)="changeType(request?.detail)"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && changeType(request?.detail)"
            >
              Alterar tipo
            </li>
            <li
              class="cursor-pointer"
              *ngIf="request?.realocatable"
              tabindex="0"
              (click)="changeRealocate(request?.detail)"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && changeRealocate(request?.detail)"
            >
              Realocar EDP
            </li>
          </ul>
        </div>
        <!-- BUTTON ACTION RET CANCEL && REOPEN -->
        <div class="btn-group" *appRequestPermission="createPermission">
          <button class="edp-btn btn-yellow" *ngIf="showActions()" (click)="cancelRequest(request?.detail)">
            Anular
          </button>
          <button
            class="edp-btn btn-yellow"
            *ngIf="request?.detail?.statusUniqueCode === 'pt.edp.request?.status.3'"
            (click)="reOpenRequest(request?.detail)"
          >
            Reabrir
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="request__detail" *ngIf="authService.isAuthenticated()">
  <!-- REQUEST DETAIL -->
  <div class="container" *ngIf="request">
    <div class="row">
      <div class="col-md-12">
        <h2 color="black" class="mb">DADOS GERAIS</h2>
      </div>
    </div>
    <div class="row no-padding row-column">
      <div class="column col-md-12">
        <p><strong>Área:</strong> {{ request?.detail?.requestArea }}</p>
        <p><strong>Tipo 1:</strong>{{ request?.detail?.requestType || '-' }}</p>
        <p><strong>Tipo 2:</strong> {{ request?.detail?.requestSubType || '-' }}</p>
        <p *ngFor="let field of request?.fields">
          <strong>{{ field?.fieldName }}:</strong> {{ field?.fieldValue || '-' }}
        </p>
        <p><strong>Nível de tensão:</strong> {{ request?.detail?.voltageLevelTitle || '-' }}</p>
        <p *ngIf="!isRet"><strong>Comercializadora:</strong> {{ request?.detail?.retailerName || '-' }}</p>
      </div>
      <div class="column col-md-12">
        <p><strong>ID:</strong> {{ request?.detail?.requestMainId || '-' }}</p>
        <p><strong>Estado:</strong> {{ request?.detail?.statusTitle }}</p>
        <p><strong>Criado por:</strong> {{ request?.detail?.createdBy || '-' }}</p>
        <p>
          <strong>Data de criação: </strong
          >{{ request?.detail?.createdAt | amFromUtc | amDateFormat: 'DD/MM/YYYY' || '-' }}
        </p>
        <p *ngIf="!showActions()">
          <strong>Data de fim:</strong>
          {{ request?.detail?.modifiedAt | amFromUtc | amDateFormat: 'DD/MM/YYYY' || '-' }}
        </p>
        <p *ngIf="!isRet && !showActions()">
          <strong>Atribuído a:</strong> {{ request?.detail?.assignedUserName || '-' }}
        </p>
      </div>
    </div>
    <div class="row no-padding">
      <div class="col-md-12">
        <p><strong>Descrição:</strong> {{ request?.detail?.requestDescription }}</p>
      </div>
    </div>
    <div class="row no-padding" *ngIf="requestAttachments.length > 0">
      <div class="col-md-12">
        <h2 color="black">ANEXOS</h2>

        <app-edp-attachments
          [fileList]="requestAttachments"
          [insertAttachment]="false"
          [maxFileSize]="15728640"
          (outputFileList)="synchronizeFiles($event, true)"
          (downloadCallBack)="downloadFile($event)"
          (deleteCallBack)="deleteFile($event)"
        ></app-edp-attachments>
      </div>
    </div>
    <!-- COMMENTS -->
    <div class="row">
      <div class="col-md-12">
        <h2 color="black" class="mb">RESPOSTA(S)</h2>
        <table class="table middle" *ngIf="request?.comments && request?.comments.length > 0; else elseNoComments">
          <thead>
            <tr>
              <th>Utilizador</th>
              <th>Resposta</th>
              <th>Estado</th>
              <th>Data de criação</th>
              <th>Anexos</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of request?.comments">
              <td width="11%">
                {{ item.userName || '-' }}
                <img
                  *ngIf="checkIsRetailer(item.createdUserIsInternal)"
                  alt="EDP - Distribuição"
                  src="/assets/images/quem-somos.png"
                />
              </td>
              <td width="57%" class="word-break text-left">{{ item.commentText || '-' }}</td>
              <td width="13%">{{ isRet ? item.statusTitleRetailer : item.statusTitleInternal }}</td>
              <td width="13%">{{ item.createdAt | amFromUtc | amLocal | amDateFormat: 'DD/MM/YYYY HH:mm' || '-' }}</td>
              <td width="6%">
                <div *ngIf="item.countAttachments === 0">-</div>
                <div
                  *ngIf="item.countAttachments === 1"
                  (click)="downloadFile(item)"
                  (keydown.enter)="downloadFile(item)"
                  (keydown.space)="downloadFile(item)"
                  class="cursor-pointer"
                  tabindex="0"
                >
                  <i class="glyphicon glyphicon-paperclip"></i>
                </div>
                <div
                  *ngIf="item.countAttachments > 1"
                  (click)="seeAttachmentsList(item)"
                  (keydown.enter)="seeAttachmentsList(item)"
                  (keydown.space)="seeAttachmentsList(item)"
                  class="cursor-pointer length_badge"
                  tabindex="1"
                >
                  <i class="glyphicon glyphicon-paperclip"></i>
                  <sub>{{ item.countAttachments }}</sub>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-template #elseNoComments>
          <p>De momento não existem respostas.</p>
        </ng-template>
      </div>
    </div>
    <div class="row" *appRequestPermission="writePermission">
      <div class="col-md-12">
        <form [formGroup]="sendCommentForm" autocomplete="off" *ngIf="showCommentForm()">
          <div class="form-group">
            <textarea
              formControlName="comment"
              class="form-control"
              id="comment"
              placeholder="Insira a sua resposta"
            ></textarea>
          </div>
          <div
            class="form-group alert alert-danger text-center"
            *ngIf="sendCommentForm.controls['comment'].hasError('maxlength')"
          >
            Resposta está a exceder o limite de caracteres.
          </div>
          <div class="form-group alert alert-danger text-center" *ngIf="fileTooLarge">
            Ficheiro é superior ao tamanho máximo permitido (15MB)
          </div>
          <div class="form-group">
            <app-edp-attachments
              [fileList]="fileList"
              [insertAttachment]="true"
              [isBtnType]="true"
              [maxFileSize]="15728640"
              (outputFileList)="synchronizeFiles($event, false)"
              (invalidFile)="fileIsInvalid($event)"
            ></app-edp-attachments>
            <div class="btn-group pull-right">
              <button
                [disabled]="!sendCommentForm.valid"
                type="submit"
                class="edp-btn btn-yellow"
                (click)="sendComment(0)"
              >
                Inserir
              </button>
              <button
                [disabled]="!sendCommentForm.valid"
                type="reset"
                class="edp-btn btn-gray"
                (click)="clearComment(0)"
              >
                Limpar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- END COMMENTS -->
    <!-- INTERNAL NOTES -->
    <div class="row" *appRequestPermission="internalNotesPermission">
      <div class="col-md-12">
        <h2 color="black" class="mb">NOTA(S) INTERNA(S)</h2>
        <table
          class="table middle"
          *ngIf="request?.internalComments && request?.internalComments.length > 0; else elseNoInternalComments"
        >
          <thead>
            <tr>
              <th>Utilizador</th>
              <th>Nota interna</th>
              <th>Estado</th>
              <th>Data de criação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of request?.internalComments">
              <td width="16%">{{ item.userName || '-' }}</td>
              <td width="56%" class="word-break text-left">{{ item.commentText || '-' }}</td>
              <td width="12%">
                {{ checkIsRetailer(item.createdUserIsInternal) ? item.statusTitleInternal : item.statusTitleRetailer }}
              </td>
              <td width="16%">{{ item.createdAt | amFromUtc | amLocal | amDateFormat: 'DD/MM/YYYY HH:mm' || '-' }}</td>
            </tr>
          </tbody>
        </table>
        <ng-template #elseNoInternalComments>
          <p>De momento não existem notas internas.</p>
        </ng-template>
      </div>
    </div>
    <div class="row" *appRequestPermission="internalNotesPermission">
      <div class="col-md-12">
        <form [formGroup]="sendInternalCommentForm" autocomplete="off" *ngIf="showCommentForm()">
          <div class="form-group">
            <textarea
              formControlName="internalnotes"
              class="form-control"
              id="internalnotes"
              placeholder="Insira a sua nota interna"
            ></textarea>
          </div>
          <div
            class="form-group alert alert-danger text-center"
            *ngIf="sendInternalCommentForm.controls['internalnotes'].hasError('maxlength')"
          >
            Nota interna está a exceder o limite de caracteres.
          </div>
          <div class="form-group">
            <div class="btn-group pull-right">
              <button
                [disabled]="!sendInternalCommentForm.valid"
                type="submit"
                class="edp-btn btn-yellow"
                (click)="sendComment(1)"
              >
                Inserir
              </button>
              <button
                [disabled]="!sendInternalCommentForm.valid"
                type="reset"
                class="edp-btn btn-gray"
                (click)="clearComment(1)"
              >
                Limpar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- END INTERNAL NOTES -->
  </div>
</section>
